import IPackingListViewOptions from "../../models/IPackingListViewOptions";
import IViewOptions from "../../models/IViewOptions";
import ControlTypeEnum from "../../models/ControlTypeEnum";
import { useMemo } from "react";
import ISupplierModel from "../../models/ISupplierModel";

export const usePackingListViewOptionsUI = (view: IPackingListViewOptions, supplierModel: ISupplierModel) => {
    const viewOptions: IViewOptions[] = useMemo(() => {
        const options = [
            {
                title: "hide_business_details",
                prop: "hideBusinessName",
                type: ControlTypeEnum.checkbox,
                value: view.hideBusinessName,
            },
            {
                title: "inline_logo_name",
                prop: "inlineLogoName",
                type: ControlTypeEnum.checkbox,
                value: view.inlineLogoName,
            },
            {
                title: "show_item_photo",
                prop: "showItemPhoto",
                type: ControlTypeEnum.checkbox,
                value: view.showItemPhoto,
            },
            {
                title: "show_item_no",
                prop: "showItemNo",
                type: ControlTypeEnum.checkbox,
                value: view.showItemNo,
            },
            {
                title: "show_item_name",
                prop: "showItemName",
                type: ControlTypeEnum.checkbox,
                value: view.showItemName,
            },
            {
                title: "show_sku",
                prop: "showSku",
                type: ControlTypeEnum.checkbox,
                value: view.showSku,
            },
            {
                // sku as barcode in other version?
                title: "show_sku_barcode",
                prop: "hideSkuCol",
                type: ControlTypeEnum.checkbox,
                value: view.hideSkuCol,
            },
            {
                title: "show_order_description",
                prop: "showOrderDescription",
                type: ControlTypeEnum.checkbox,
                value: view.showOrderDescription,
            },
            {
                title: "show_do_not_ship_before_date",
                prop: "showDoNotShipBeforeDate",
                type: ControlTypeEnum.checkbox,
                value: view.showDoNotShipBeforeDate,
            },
            {
                title: "show_upc",
                prop: "showUpc",
                type: ControlTypeEnum.checkbox,
                value: view.showUpc,
            },
            {
                title: "show_phone",
                prop: "showPhone",
                type: ControlTypeEnum.checkbox,
                value: view.showPhone,
            },
            {
                title: "show_email",
                prop: "showEmail",
                type: ControlTypeEnum.checkbox,
                value: view.showEmail,
            },
            {
                title: "show_order_qty",
                prop: "showOrderQty",
                type: ControlTypeEnum.checkbox,
                value: view.showOrderQty,
            },
            {
                title: "show_ship_qty",
                prop: "showShipQty",
                type: ControlTypeEnum.checkbox,
                value: view.showShipQty,
            },
            {
                title: "show_dropshipment",
                prop: "showDropshipment",
                type: ControlTypeEnum.checkbox,
                value: view.showDropshipment,
            },
            {
                title: "show_bill_to",
                prop: "showBillTo",
                type: ControlTypeEnum.checkbox,
                value: view.showBillTo,
            },
            {
                title: "show_bill_to_phone",
                prop: "showBillToPhone",
                type: ControlTypeEnum.checkbox,
                value: view.showBillToPhone,
            },
            {
                title: "show_ship_to_phone",
                prop: "showShipToPhone",
                type: ControlTypeEnum.checkbox,
                value: view.showShipToPhone,
            },
            {
                title: "show_order_user",
                prop: "showOrderUser",
                type: ControlTypeEnum.checkbox,
                value: view.showOrderUser,
            },
            {
                title: "show_uom",
                prop: "showUom",
                type: ControlTypeEnum.checkbox,
                value: view.showUom,
            },
            {
                title: "show_unit_price",
                prop: "showUnitPrice",
                type: ControlTypeEnum.checkbox,
                value: view.showUnitPrice,
            },
        ];

        if (supplierModel.has_pick_list_management) {
            options.push({
                title: "show_pick_qty",
                prop: "showPickQty",
                type: ControlTypeEnum.checkbox,
                value: view.showPickQty,
            });

            options.push({
                title: "show_packing_list_name",
                prop: "showPackingListName",
                type: ControlTypeEnum.checkbox,
                value: view.showPackingListName,
            });
        } else {
            options.push({
                title: "show_item_location",
                prop: "showItemLocation",
                type: ControlTypeEnum.checkbox,
                value: view.showItemLocation,
            });
        }

        if (supplierModel.has_dimensions) {
            options.push({
                title: "show_dimensions",
                prop: "showDimensions",
                type: ControlTypeEnum.checkbox,
                value: view.showDimensions,
            });
        }

        options.push({
            title: "show_item_options_col",
            prop: "showItemOptions",
            type: ControlTypeEnum.checkbox,
            value: view.showItemOptions,
        });

        return options;
    }, [view]);

    return viewOptions;
};
